import $script from 'scriptjs';

import {
  socialSessionLoading,
  socialSessionError,
  socialSessionRedirect,
} from 'lib/social-session-helpers';

export default class FacebookLogin {
  constructor(buttonTarget, textTarget, csrfToken) {
    this.buttonTarget = buttonTarget;
    this.textTarget = textTarget;
    this.csrfToken = csrfToken;

    this.init();
  }

  init() {
    socialSessionError(false, this.buttonTarget);

    this.authType = 'reauthorize';

    $script('https://connect.facebook.net/en_US/sdk.js', this.loadFacebookApi);
  }

  loadFacebookApi = () => {
    window.FB.init({
      appId: this.buttonTarget.dataset.appId,
      autoLogAppEvents: true,
      cookie: true,
      status: true,
      xfbml: false,
      version: 'v3.2',
    });
  }

  connect() {
    this.originalText = this.textTarget.innerHTML;

    socialSessionLoading(this.buttonTarget);

    this.login().then(
      () => {
        this.validate().then(
          this.loginResolve,
          () => {
            this.loginReject(true);
          },
        );
      },
      this.loginReject,
    );
  }

  loginResolve = () => {
    socialSessionRedirect(this.buttonTarget,
      this.csrfToken,
      this.buttonTarget.dataset.omniauthPath);
  }

  loginReject = (error = false) => {
    socialSessionLoading(this.buttonTarget, this.originalText);
    socialSessionError(error, this.buttonTarget);

    if (error) this.authType = 'rerequest';
  }

  login() {
    return new Promise((resolve, reject) => {
      window.FB.login(
        (response) => {
          if (response.status === 'connected') {
            resolve();
          } else {
            reject();
          }
        },
        { scope: 'public_profile,email', auth_type: this.authType },
      );
    });
  }

  validate() {
    return new Promise((resolve, reject) => {
      window.FB.api('/me/permissions', (response) => {
        response.data.forEach((permission) => {
          if (
            permission.permission === 'email'
            && permission.status !== 'granted'
          ) {
            reject();
          }

          if (
            permission.permission === 'public_profile'
            && permission.status !== 'granted'
          ) {
            reject();
          }
        });

        resolve();
      });
    });
  }
}
